(() => {
  const productCache = new Map();
  let availabilitySort = 'default';

  const getProductPath = (link) => {
    try {
      const url = new URL(link.href, window.location.origin);
      const match = url.pathname.match(/\/products\/[^/?#]+/);
      return match ? match[0] : null;
    } catch (_error) {
      return null;
    }
  };

  const isNurseryOnly = (variant) => {
    const title = String(variant.public_title || variant.title || '').toLowerCase();
    return title.includes('no shipping') && !title.includes('no shipping to');
  };

  const getAvailability = (productPath) => {
    if (!productCache.has(productPath)) {
      productCache.set(
        productPath,
        fetch(`${productPath}.js`, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
            return response.json();
          })
          .then((product) => {
            const variants = Array.isArray(product.variants) ? product.variants : [];
            const availableVariants = variants.filter((variant) => variant.available);
            return {
              available: availableVariants.length > 0,
              availableOnline: availableVariants.some((variant) => !isNurseryOnly(variant)),
            };
          })
          .catch(() => null),
      );
    }

    return productCache.get(productPath);
  };

  const getAutocompleteCard = (link) => {
    const container = link.closest('.omega__products');
    if (!container) return link.closest('li, .omega__product, .omega__item');

    const productPaths = new Set(
      [...container.querySelectorAll('a[href*="/products/"]')]
        .map(getProductPath)
        .filter(Boolean),
    );

    if (productPaths.size <= 1) return container;

    let card = link;
    while (card.parentElement && card.parentElement !== container) card = card.parentElement;
    return card;
  };

  const availabilityRank = (card) => {
    if (availabilitySort === 'available') return card.dataset.availableNow === 'true' ? 0 : 1;
    if (availabilitySort === 'online') return card.dataset.availableOnlineNow === 'true' ? 0 : 1;
    return 0;
  };

  const sortResults = () => {
    document.querySelectorAll('.os-index-products .hits-component .grid.grid--uniform').forEach((grid) => {
      const cards = [...grid.children];
      cards.forEach((card, index) => {
        if (!card.dataset.omegaOriginalPosition) card.dataset.omegaOriginalPosition = String(index);
      });

      cards
        .sort((a, b) => {
          const rankDifference = availabilityRank(a) - availabilityRank(b);
          if (rankDifference) return rankDifference;
          return Number(a.dataset.omegaOriginalPosition) - Number(b.dataset.omegaOriginalPosition);
        })
        .forEach((card) => grid.append(card));
    });
  };

  const addStatus = (card, link) => {
    if (!card || card.dataset.omegaAvailabilityChecked === 'true') return;

    const productPath = getProductPath(link);
    if (!productPath) return;
    card.dataset.omegaAvailabilityChecked = 'true';

    getAvailability(productPath).then((availability) => {
      if (!availability) return;

      card.dataset.availableNow = String(availability.available);
      card.dataset.availableOnlineNow = String(availability.availableOnline);

      const existingStatus = card.querySelector('.product-card__availability, .omega-stock-status');
      if (!existingStatus && (!availability.available || !availability.availableOnline)) {
        const status = document.createElement('span');
        status.className = 'omega-stock-status';
        status.textContent = availability.available ? 'Nursery availability only' : 'Out of stock';
        const destination =
          card.querySelector('.product-card__info') ||
          card.querySelector('.omega__content, .omega__product-info, .omega__title') ||
          card;
        destination.append(status);
      }

      sortResults();
    });
  };

  const addSortControl = (toolbar) => {
    if (toolbar.querySelector('.omega-availability-sort')) return;

    const wrapper = document.createElement('label');
    wrapper.className = 'omega-availability-sort';
    wrapper.append('Availability');

    const select = document.createElement('select');
    select.setAttribute('aria-label', 'Sort plant search results by availability');
    select.innerHTML = `
      <option value="default">Default order</option>
      <option value="available">Available now first</option>
      <option value="online">Available online now first</option>
    `;
    select.value = availabilitySort;
    select.addEventListener('change', () => {
      availabilitySort = select.value;
      document.querySelectorAll('.omega-availability-sort select').forEach((otherSelect) => {
        otherSelect.value = availabilitySort;
      });
      sortResults();
    });
    wrapper.append(select);

    const existingSort = toolbar.querySelector('.os-toolbar-sort');
    if (existingSort) existingSort.before(wrapper);
    else toolbar.append(wrapper);
  };

  const scan = (root = document) => {
    const fullCards = [];
    if (root instanceof Element && root.matches('.os-index-products .product-card')) fullCards.push(root);
    root.querySelectorAll?.('.os-index-products .product-card').forEach((card) => fullCards.push(card));

    fullCards.forEach((card) => {
      const link = card.matches('a[href*="/products/"]')
        ? card
        : card.querySelector('a[href*="/products/"]');
      const gridItem = card.closest('.grid__item') || card;
      if (link) addStatus(gridItem, link);
    });

    const toolbars = [];
    if (root instanceof Element && root.matches('.os-index-products .os-toolbar')) toolbars.push(root);
    root.querySelectorAll?.('.os-index-products .os-toolbar').forEach((toolbar) => toolbars.push(toolbar));
    toolbars.forEach(addSortControl);

    const autocompleteLinks = [];
    if (root instanceof Element && root.matches('.omega__autocomplete a[href*="/products/"]')) {
      autocompleteLinks.push(root);
    }
    root.querySelectorAll?.('.omega__autocomplete a[href*="/products/"]').forEach((link) => {
      autocompleteLinks.push(link);
    });
    autocompleteLinks.forEach((link) => addStatus(getAutocompleteCard(link), link));
  };

  const initialize = () => {
    scan();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
